/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_New_Folder_PlaceholderInputs */

const en_explorer_display_new_folder_placeholder = /** @type {(inputs: Explorer_Display_New_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`untitled`)
};

const fr_explorer_display_new_folder_placeholder = /** @type {(inputs: Explorer_Display_New_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sans titre`)
};

const de_explorer_display_new_folder_placeholder = /** @type {(inputs: Explorer_Display_New_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ohne Titel`)
};

const it_explorer_display_new_folder_placeholder = /** @type {(inputs: Explorer_Display_New_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`senza titolo`)
};

const ru_explorer_display_new_folder_placeholder = /** @type {(inputs: Explorer_Display_New_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`без названия`)
};

const es_explorer_display_new_folder_placeholder = /** @type {(inputs: Explorer_Display_New_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`intitulado`)
};

const zh_cn2_explorer_display_new_folder_placeholder = /** @type {(inputs: Explorer_Display_New_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无题`)
};

const ja_explorer_display_new_folder_placeholder = /** @type {(inputs: Explorer_Display_New_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無題`)
};

const hi_explorer_display_new_folder_placeholder = /** @type {(inputs: Explorer_Display_New_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्षकहीन`)
};

const pt_pt2_explorer_display_new_folder_placeholder = /** @type {(inputs: Explorer_Display_New_Folder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sem título`)
};

/**
* | output |
* | --- |
* | "untitled" |
*
* @param {Explorer_Display_New_Folder_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_new_folder_placeholder = /** @type {((inputs?: Explorer_Display_New_Folder_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_New_Folder_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_new_folder_placeholder(inputs)
	if (locale === "de") return de_explorer_display_new_folder_placeholder(inputs)
	if (locale === "it") return it_explorer_display_new_folder_placeholder(inputs)
	if (locale === "ru") return ru_explorer_display_new_folder_placeholder(inputs)
	if (locale === "es") return es_explorer_display_new_folder_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_new_folder_placeholder(inputs)
	if (locale === "ja") return ja_explorer_display_new_folder_placeholder(inputs)
	if (locale === "hi") return hi_explorer_display_new_folder_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_new_folder_placeholder(inputs)
	return en_explorer_display_new_folder_placeholder(inputs)
});